<template>
<!-- 勤務表エラーメッセージ -->
<div>
  <p style="color: red;" v-for="error in startEmpty" :key="error">{{ '※' + error }}</p>
  <p style="color: red;" v-for="error in startRegex" :key="error">{{ '※' + error }}</p>
  <p style="color: red;" v-for="error in endEmpty" :key="error">{{ '※' + error }}</p>
  <p style="color: red;" v-for="error in endRegex" :key="error">{{ '※' + error }}</p>
  <p style="color: red;" v-for="error in restEmpty" :key="error">{{ '※' + error }}</p>
  <p style="color: red;" v-for="error in restRegex" :key="error">{{ '※' + error }}</p>
  <p style="color: red;" v-for="error in attendance1Empty" :key="error">{{ '※' + error }}</p>
  <p style="color: red;" v-for="error in attendance2Empty" :key="error">{{ '※' + error }}</p>
  <p style="color: red;" v-for="error in remarksEmpty" :key="error">{{ '※' + error }}</p>
</div>
</template>

<script>
import ConstList from './../ConstList'
export default {
  name: 'RosterError',
  data() {
    return {
      startEmpty: [],
      startRegex: [],
      endEmpty: [],
      endRegex: [],
      restEmpty: [],
      restRegex: [],
      attendance1Empty: [],
      attendance2Empty: [],
      remarksEmpty: []
    }
  },
  props: {
    monthDay: Array,
    outBasic: String,
    startBasic: String,
    endBasic: String,
    breakBasic: String,
    start: Array,
    end: Array,
    rest: Array,
    attendance1: Array,
    attendance2: Array,
    remarks: Array
  },
  methods: {
    // 開始時刻の空文字チェック
    start_empty: function () {
      // let error = this.startEmpty
      // this.start.forEach((value, i, array) => {
      //   if (((this.end[i] !== "") || (this.rest[i] !== "") || (this.attendance1[i] !== "") || (this.remarks[i] !== "")) && (array[i] === "")) {
      //     error.splice(i, 1, i + 1 + '日の開始時刻を入力してください ')
      //     let set = Array.from(new Set(error))
      //     error = set
      //   } else {
      //     error.splice(i, 1)
      //   }
      // })
    },
    // 開始時刻の入力形式チェック
    start_regex: function () {
      // let error = this.startRegex
      // this.start.forEach((value, i) => {
      //   if ((value !== "") && (!value.match(/^\d{2}:\d{2}$/))) {
      //     error.splice(i, 1, i + 1 + '日の開始時刻は入力例のように、半角数字と記号を用いて入力してください ')
      //     let set = Array.from(new Set(error))
      //     error = set
      //   } else {
      //     error.splice(i, 1)
      //   }
      // })
    },
    // 終了時刻の空文字チェック
    end_empty: function () {
      // let error = this.endEmpty
      // this.end.forEach((value, i, array) => {
      //   if (((this.start[i] !== "") || (this.rest[i] !== "") || (this.attendance1[i] !== "") || (this.remarks[i] !== "")) && (array[i] === "")) {
      //     error.splice(i, 1, i + 1 + '日の終了時刻を入力してください ')
      //     let set = Array.from(new Set(error))
      //     error = set
      //   } else {
      //     error.splice(i, 1)
      //   }
      // })
    },
    // 終了時刻の入力形式チェック
    end_regex: function () {
      // let error = this.endRegex
      // this.end.forEach((value, i) => {
      //   if ((value !== "") && (!value.match(/^\d{2}:\d{2}$/))) {
      //     error.splice(i, 1, i + 1 + '日の終了時刻は入力例のように、半角数字と記号を用いて入力してください ')
      //     let set = Array.from(new Set(error))
      //     error = set
      //   } else {
      //     error.splice(i, 1)
      //   }
      // })
    },
    // 休憩の空文字チェック
    rest_empty: function () {
      // let error = this.restEmpty
      // this.rest.forEach((value, i, array) => {
      //   if (((this.start[i] !== "") || (this.end[i] !== "") || (this.attendance1[i] !== "") || (this.remarks[i] !== "")) && (array[i] === "")) {
      //     error.splice(i, 1, i + 1 + '日の休憩を入力してください ')
      //     let set = Array.from(new Set(error))
      //     error = set
      //   } else {
      //     error.splice(i, 1)
      //   }
      // })
    },
    // 休憩の入力形式チェック
    rest_regex: function () {
      // let error = this.restRegex
      // this.rest.forEach((value, i) => {
      //   if ((value !== "") && (!value.match(/^\d{2}:\d{2}$/))) {
      //     error.splice(i, 1, i + 1 + '日の休憩は入力例のように、半角数字と記号を用いて入力してください ')
      //     let set = Array.from(new Set(error))
      //     error = set
      //   } else {
      //     error.splice(i, 1)
      //   }
      // })
    },
    // 勤怠1の空文字チェック
    attendance1_empty: function () {
      // let error = this.attendance1Empty
      // this.attendance1.forEach((value, i, array) => {
      //   if (((this.start[i] !== "") || (this.end[i] !== "") || (this.rest[i] !== "") || (this.remarks[i] !== "")) && (array[i] === "")) {
      //     error.splice(i, 1, i + 1 + '日の勤怠1を選択してください ')
      //     let set = Array.from(new Set(error))
      //     error = set
      //   } else {
      //     error.splice(i, 1)
      //   }
      // })
    },
    // 勤怠2の空文字チェック
    attendance2_empty: function () {
      // let error = this.attendance2Empty
      // this.attendance2.forEach((value, i, array) => {
      //   if (((this.attendance1[i] === ConstList.MORNING_WORK) || (this.attendance1[i] === ConstList.MORNING_PAID) || (this.attendance1[i] === ConstList.MORNING_SUBSTITUTE) || (this.attendance1[i] === ConstList.MORNING_DEDUCTION)) && (array[i] === "")) {
      //     error.splice(i, 1, i + 1 + '日の勤怠2を選択してください ')
      //     let set = Array.from(new Set(error))
      //     error = set
      //   } else {
      //     error.splice(i, 1)
      //   }
      // })
    },
    // 備考・作業内容の空文字チェック
    // remarks_empty: function () {
    //   let error = this.remarksEmpty
    //   this.remarks.forEach((value, i, array) => {
    //     if (((this.start[i] !== "") || (this.end[i] !== "") || (this.rest[i] !== "") || (this.attendance1[i] !== "")) && (array[i] === "")) {
    //       error.splice(i, 1, i + 1 + '日の備考・作業内容を入力してください ')
    //       let set = Array.from(new Set(error))
    //       error = set
    //     } else {
    //       error.splice(i, 1)
    //     }
    //   })
    // }
  }
}
</script>

<style scoped>

</style>
